import type { CustomIconProps } from '../types';

const InStorePickup = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '10'}
        height={height ?? '13'}
        viewBox="0 0 10 13"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.49551 1.86417C4.79519 1.64393 5.20476 1.64393 5.50444 1.86417C5.87904 2.13947 6.09998 2.57462 6.09998 3.03714V3.97593H3.89998V3.03714C3.89998 2.57462 4.12091 2.13947 4.49551 1.86417ZM3.09998 4.76964V5.96027C3.09998 6.17945 3.27906 6.35713 3.49998 6.35713C3.72089 6.35713 3.89998 6.17945 3.89998 5.96027V4.76964H6.09998V5.96027C6.09998 6.17945 6.27906 6.35713 6.49998 6.35713C6.72089 6.35713 6.89998 6.17945 6.89998 5.96027V4.76964H8.5C8.61046 4.76964 8.7 4.85848 8.7 4.96807V10.5242L1.3 10.5242V4.96807C1.3 4.85848 1.38954 4.76964 1.5 4.76964H3.09998ZM3.09998 3.97593V3.03714C3.09998 2.32313 3.44104 1.65137 4.01933 1.22637C4.60188 0.79824 5.39807 0.79824 5.98062 1.22637C6.55891 1.65137 6.89998 2.32313 6.89998 3.03714V3.97593H8.5C9.05229 3.97593 9.5 4.42013 9.5 4.96807V11.9131C9.5 12.461 9.05229 12.9052 8.5 12.9052H1.5C0.947715 12.9052 0.5 12.461 0.5 11.9131V4.96807C0.5 4.42013 0.947715 3.97593 1.5 3.97593H3.09998ZM1.3 11.9131V11.3179L8.7 11.3179V11.9131C8.7 12.0227 8.61046 12.1115 8.5 12.1115H1.5C1.38954 12.1115 1.3 12.0227 1.3 11.9131Z"
            fill="#414042"
        />
    </svg>
);

export default InStorePickup;
